/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Edit_DescriptionInputs */



/**
* | output |
* | --- |
* | "Update this partner's name, address, and billing email." |
*
* @param {Partner_Admin_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_edit_description = /** @type {((inputs?: Partner_Admin_Edit_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Edit_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Name, Adresse und Rechnungs-E-Mail dieses Partners aktualisieren.")
	return /** @type {LocalizedString} */ ("Update this partner's name, address, and billing email.")
});